import { createStore } from 'vuex'
import popup from '../modules/popup.js'

export default createStore({
  state: {
    staturl: '/bitapi/property_insurance_policy/stat/', //URL сервера статистики
    dataurl: '/bitapi/purchase_property_insurance_policy/get_org_data/',
    pay_btn_url: '/bitapi/purchase_property_insurance_policy/pay_order/',
    response: undefined,
    show: false,
    step: 1,
    loads: [],
    tariffs: [
      {
        name: 'Базовый',
        price: '6&nbsp;000&nbsp;₽/год',
        text: 'Максимальная страховая&nbsp;сумма <span class="tariff__pricespan">250&nbsp;000&nbsp;₽</span>',
        icon: '<svg viewBox="0 0 121 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M54.569 90.5566V99.5H42.7069H60.5H78.2931H66.431V90.5566M54.569 90.5566H20.5C18.8431 90.5566 17.5 89.2135 17.5 87.5566L17.5 77.5M54.569 90.5566H60.5H66.431M74.2931 20.5H100.5C102.157 20.5 103.5 21.8431 103.5 23.5V77.5M66.431 90.5566H100.5C102.157 90.5566 103.5 89.2135 103.5 87.5566V77.5M17.5 77.5L17.5 58.6075M17.5 77.5H36M103.5 77.5H58.5" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M32.3333 12.5L47.5 12.5L62.6667 12.5C62.6667 12.5 62.6667 25.4643 75.5 25.4643C75.5 28.4107 75.5 31.5929 75.5 39.6071C75.5 60.8214 56.25 75.5536 47.5 78.5C38.75 75.5536 19.5 60.8214 19.5 39.6071C19.5 31.5929 19.5 28.4107 19.5 25.4643" stroke="#F22557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M36.8846 17.5H47.5H58.1154C58.1154 17.5 59.2949 28.0319 70.5 30.3723C70.5 30.3723 70.5 30.3723 70.5 38.6474C70.5 55.1976 54.5032 70.2014 47.5 72.5C40.4968 70.2014 24.5 55.1976 24.5 38.6474C24.5 31.5426 24.5 30.3723 24.5 30.3723" stroke="#F22557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M28.5 26.5L32.5 30.5M25.5 18.5L33.5 26.5M42.5 33.5C42.5 35.7091 40.7091 37.5 38.5 37.5C36.2909 37.5 34.5 35.7091 34.5 33.5C34.5 31.2909 36.2909 29.5 38.5 29.5C40.7091 29.5 42.5 31.2909 42.5 33.5Z" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M65.5 73.5H99.5V24.5H81.5" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M28.5 73.5H21.5V64.5" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
      },
      {
        name: 'Стандарт',
        price: '20&nbsp;000&nbsp;₽/год',
        oldprice: '24&nbsp;000&nbsp;₽',
        uppertext: 'выгоднее на 17%',
        text: 'Максимальная страховая&nbsp;сумма <span class="tariff__pricespan">1&nbsp;000&nbsp;000&nbsp;₽</span>',
        icon: '<svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M77 87V94H68H81H94H85V87M77 87H53C51.3431 87 50 85.6569 50 84V78M77 87H81H85M95.9439 37H109C110.657 37 112 38.3431 112 40V78M85 87H109C110.657 87 112 85.6569 112 84V78M50 78V60.5M50 78H57M112 78H73M95.9439 40H109V75H73M57 75H53V54" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M8 22L13.5 27.5M15 24L17 26M25 32C25 34.2091 23.2091 36 21 36C18.7909 36 17 34.2091 17 32C17 29.7909 18.7909 28 21 28C23.2091 28 25 29.7909 25 32Z" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13 98V70H46M13 98H8V98C8 101.314 10.6863 104 14 104H35H56C59.3137 104 62 101.314 62 98V98H57M13 98H30V98C30 99.1046 30.8954 100 32 100H35H38C39.1046 100 40 99.1046 40 98V98H57M57 98V91M17 94H53" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M61 51V78.5C61 80.433 62.567 82 64.5 82C66.433 82 68 80.433 68 78.5V76M60.5 17C42.1608 17 27 32.7539 27 54C27 48.0967 31.9995 43.3111 38.1667 43.3111C44.3338 43.3111 49.3333 48.0967 49.3333 54C49.3333 53.3729 49.3898 52.7583 49.498 52.1608M60.5 17C78.8392 17 94 32.7539 94 54C94 48.0967 89.0005 43.3111 82.8333 43.3111C76.6662 43.3111 71.6667 48.0967 71.6667 54C71.6667 53.3728 71.6102 52.7583 71.502 52.1608M60.5 17C72.4729 25.8161 71.6695 43.2195 71.502 52.1608M60.5 17C81.3055 23.4094 84.1951 43.3661 84.1951 43.3661M60.5 17C48.5271 25.8161 49.3305 43.2195 49.498 52.1608M60.5 17C39.6945 23.4094 36.8049 43.3661 36.8049 43.3661M49.498 52.1608C50.4088 47.1339 54.988 43.3111 60.5 43.3111C66.012 43.3111 70.5912 47.1339 71.502 52.1608M49.498 52.1608C49.5104 52.8225 49.5193 53.4379 49.5193 54M71.502 52.1608C71.4896 52.8225 71.4807 53.4379 71.4807 54" stroke="#F22557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      },
      {
        name: 'Премиум',
        price: '38&nbsp;000&nbsp;₽/год',
        text: 'Максимальная страховая&nbsp;сумма <span class="tariff__pricespan">2&nbsp;000&nbsp;000 ₽</span>',
        icon: '<svg viewBox="0 0 121 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M46.7812 97.5V104.5H37.7812H50.7812H63.7812H54.7812V97.5M46.7812 97.5H20.7812C19.1244 97.5 17.7812 96.1569 17.7812 94.5V87.5M46.7812 97.5H50.7812H54.7812M62.7812 43.5H80.7812C82.4381 43.5 83.7812 44.8431 83.7812 46.5V87.5M54.7812 97.5H80.7813C82.4381 97.5 83.7812 96.1569 83.7812 94.5V87.5M17.7812 87.5V72.5M17.7812 87.5H83.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.7812 70.5V83.5C20.7812 84.0523 21.229 84.5 21.7813 84.5H79.7813C80.3335 84.5 80.7812 84.0523 80.7812 83.5V47.5C80.7812 46.9477 80.3335 46.5 79.7812 46.5H64.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M25.7812 37.5L30.2812 42M22.7813 29.5L30.7812 37.5M33.7812 35.5L36.7812 38.5M40.7812 45.5C40.7812 47.7091 38.9904 49.5 36.7812 49.5C34.5721 49.5 32.7812 47.7091 32.7812 45.5C32.7812 43.2909 34.5721 41.5 36.7812 41.5C38.9904 41.5 40.7812 43.2909 40.7812 45.5Z" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M80.7812 34.5H89.7812M97.2812 34.5H97.7812M102.281 34.5H102.781M75.7812 29.5H107.781V39.5H75.7812V29.5Z" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M80.7812 21.5H89.7812M97.2812 21.5H97.7812M102.281 21.5H102.781M75.7812 16.5H107.781V26.5H75.7812V16.5Z" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M87.7812 86.5H89.7812M97.2812 86.5H97.7812M102.281 86.5H102.781M87.7812 81.5L107.781 81.5V91.5H89.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M87.7812 73.5H89.7812M97.2812 73.5H97.7812M102.281 73.5H102.781M90.7812 68.5H107.781V78.5H87.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M87.7812 60.5H89.7812M97.2812 60.5H97.7812M102.281 60.5H102.781M87.7812 55.5L107.781 55.5V65.5H87.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M87.7812 47.5H89.7812M97.2812 47.5H97.7812M102.281 47.5H102.781M87.7812 42.5L107.781 42.5V52.5H87.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M84.7812 99.5H89.7812M97.2812 99.5H97.7812M102.281 99.5H102.781M75.7812 101.5V104.5H107.781V94.5H91.7812" stroke="#343540" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13.7812 20.7C28.0987 22.6886 35.7812 16.5 35.7812 16.5C35.7812 16.5 43.4638 22.6886 57.7813 20.7L57.7812 51.62C57.7812 64.8771 42.0669 70.8429 35.7812 72.5C29.4956 70.8429 13.7813 64.8771 13.7813 51.62L13.7812 20.7Z" stroke="#F22557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17.7812 24.95C29.4955 26.5835 35.7812 21.5 35.7812 21.5C35.7812 21.5 42.067 26.5835 53.7813 24.95L53.7812 50.3486C53.7812 61.2384 40.9241 66.1388 35.7812 67.5C30.6384 66.1388 17.7813 61.2384 17.7813 50.3486L17.7812 24.95Z" stroke="#F22557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      },
    ],
    sberlink: './',
    notsberlink: './',
    isOrderCreated: false,
    form: {
      tariff: '',
      type: '',
      name: '',
      INN: '',
      email: '',
      tel: '',
      site: '',
    },
    required: {
      tariff: true,
      type: true,
      name: true,
      INN: true,
      email: true,
      tel: true,
      site: false,
    },
    errors: {
      INN: '',
      email: '',
      tel: '',
      site: '',
    }
  },
  mutations: {
    addLoad(state, val){
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val){
      state.loads = state.loads.filter(el=>el!=val)
    },
    setShow(state,val) {
      state.show = val
    },
    setResponse(state,val) {
      state.response = val
    },
    nextStep(state){
      state.step ++
    },
    prevStep(state) {
      state.step --
    }
  },
  getters: {
    formfilled(state) {
      for (let key in state.required)
        if (state.required[key] && !state.form[key]) return false
      for (let error of Object.values(state.errors))
        if (error) return false
      return true
    },
    loading(state){
      return state.loads.length ? true : false
    },
  },
  actions: {
    nextStep({commit}){
      commit('nextStep')
      document.querySelector('.umoney').scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    prevStep({commit}){
      commit('prevStep')
      document.querySelector('.umoney').scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async sendData({state, commit}){
      let ok = false, status
      commit('addLoad', 'sendData')
      await fetch(state.dataurl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(state.form)
        })
        .then(async res=>{
          status = res.status
          if (!res.ok) throw(await res.text())
          return res.json()
        })
        .then(json=> commit('setResponse', json))
        .then(()=>ok = true)
        .catch(err=>{ 
          let str = 'Что-то пошло нет так!\n'
          if (typeof(err) == 'string') {
            if (err.match('<title>'))
              str += `Код ошибки: ` + status
            else
              str += err 
          }      
          commit('showMessage', { title: 'Ошибка', text: str, btnText: 'ОК' })
          ok = false 
        })

      commit('removeLoad', 'sendData')
      return ok
    },
    async payButtonPress({state, commit}, payMethod){
      if (state.isOrderCreated) return;

      //eslint-disable-next-line no-unused-vars
      commit('addLoad', 'payButtonPress')
      let dadata = state.response // JSON-Ответ из шага 2 (дадата)
      let fields = { ...state.form, method: payMethod }
      let body = {
        fields,
        dadata
      }
      let status
      await fetch(state.pay_btn_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
      .then(async res=>{
        status = res.status
        if (!res.ok) throw(await res.text())
        return res.json()
      })
      .then(json=>{
        if (!json.error)
          state.isOrderCreated = true;

        if (json.link)
          return window.location.assign(json.link)
        if (json.error)
          throw(json.error)
        commit('showMessage', { title: 'Успешно', text: `Данные отправлены на адрес ${state.form.email}, проверьте почтовый ящик`, btnText: 'ОК', redirect: '/umoney/' })
      })
      .catch(err=>{ 
        let str = 'Что-то пошло нет так!\n'
        if (typeof(err) == 'string') {
          if (err.match('<title>'))
            str += `Код ошибки: ` + status
          else
            str += err 
        }
        commit('showMessage', { title: 'Ошибка', text: str, btnText: 'ОК' })
      })
      commit('removeLoad', 'payButtonPress')
    },
    callAction({ state }, action){
      fetch(state.staturl + `?action=${encodeURIComponent(action)}`)
      .then(res=>{
        if (!res.ok) throw(res.status)
      })
      .catch(err=>console.error(err))
    }
  },
  modules: {
    popup
  }
})
